import { Project, ProjectAndCustomer } from './projectType';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


class ProjectApi {

    static async create(project: Project) {
        try {

            //console.log('=====project======', project)

            const response = await fetch(`${API_BASE_URL}/projects`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ project: project }),
                credentials: 'include', // Include cookies in the request
            });

            //const headers: { [key: string]: string } = {};
            //response.headers.forEach((value, key) => { headers[key] = value; });
            const responseBody = await response.json();
            if (response.status === 201) {
                return responseBody
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else {

                if (responseBody.error.includes('duplicate')) {
                    // This checks if the word "duplicate" appears in the error message
                    //throw new Error('Duplicated data entries' || `Error: Status ${response.status}`);
                    throw new Error(`Duplicated data entries status ${response.status}`);
                }
                else {
                    throw new Error(`${responseBody.error} status ${response.status}`);
                }

            }

        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to create project: ${error.message}`);
            } else {
                throw new Error('Failed to create project: An unknown error occurred.');
            }
        }
    }


    static async getProjectsByCustomer(customerId: string) {
        try {
            const response = await fetch(`${API_BASE_URL}/customers/${customerId}/projects`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include', // Include cookies in the request
            });

            //console.log('=====response======', response)
            const responseBody = await response.json();

            if (response.status === 200) {

                const projects: ProjectAndCustomer[] = responseBody.data.map((item: any) => {
                    return {
                        project_id: item.attributes.project_id,
                        name: item.attributes.name,
                        project_description: item.attributes.project_description,
                        project_type: item.attributes.project_type,
                        estimated_sum: item.attributes.estimated_sum,
                        estimated_duration_days: item.attributes.estimated_duration_days,
                        start_date: item.attributes.start_date,
                        end_date: item.attributes.end_date,
                        company_code: item.attributes.company_code,
                        customer_id: item.attributes.customer_id,
                        customer_first_name: item.attributes.customer_first_name,
                        customer_last_name: item.attributes.customer_last_name,
                        customer_address_1: item.attributes.customer_address_1,
                        customer_city: item.attributes.customer_city,
                        customer_state: item.attributes.customer_state,
                        customer_zip: item.attributes.customer_zip,
                        customer_phone: item.attributes.customer_phone,
                        customer_email: item.attributes.customer_email,
                        created_at: item.attributes.created_at,
                        updated_at: item.attributes.updated_at
                    };
                });

                return projects;
            }
            else if (response.status === 404) { //for no companies is found with this account!!
                return [];
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Session expired. Try to refresh your browser.`);
            }
            else {

                throw new Error(`${responseBody.error} status ${response.status}`);
            }


        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to get project: ${error.message}`);
            } else {
                throw new Error('Failed to get project: An unknown error occurred.');
            }
        }
    }


    static async getProjectsAndCustomers() {
        try {
            const response = await fetch(`${API_BASE_URL}/projects/projects_and_customers`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include', // Include cookies in the request
            });

            //console.log('=====response======', response)
            const responseBody = await response.json();

            if (response.status === 200) {

                const projects: ProjectAndCustomer[] = responseBody.data.map((item: any) => {
                    return {
                        project_id: item.attributes.project_id,
                        name: item.attributes.name,
                        project_description: item.attributes.project_description,
                        project_type: item.attributes.project_type,
                        estimated_sum: item.attributes.estimated_sum,
                        estimated_duration_days: item.attributes.estimated_duration_days,
                        start_date: item.attributes.start_date,
                        end_date: item.attributes.end_date,
                        company_code: item.attributes.company_code,
                        customer_id: item.attributes.customer_id,
                        customer_first_name: item.attributes.customer_first_name,
                        customer_last_name: item.attributes.customer_last_name,
                        customer_address_1: item.attributes.customer_address_1,
                        customer_city: item.attributes.customer_city,
                        customer_state: item.attributes.customer_state,
                        customer_zip: item.attributes.customer_zip,
                        customer_phone: item.attributes.customer_phone,
                        customer_email: item.attributes.customer_email,
                        created_at: item.attributes.created_at,
                        updated_at: item.attributes.updated_at
                    };
                });

                return projects;
            }
            else if (response.status === 404) { //for no companies is found with this account!!
                return [];
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Session expired. Try to refresh your browser.`);
            }
            else {

                throw new Error(`${responseBody.error} status ${response.status}`);
            }


        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to get project: ${error.message}`);
            } else {
                throw new Error('Failed to get project: An unknown error occurred.');
            }
        }
    }


    static async get() {
        try {
            const response = await fetch(`${API_BASE_URL}/projects/`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include', // Include cookies in the request
            });

            //console.log('=====response======', response)
            const responseBody = await response.json();

            if (response.status === 200) {

                const projects: Project[] = responseBody.data.map((item: any) => {
                    return {
                        project_id: item.attributes.project_id,
                        name: item.attributes.name,
                        project_description: item.attributes.project_description,
                        project_type: item.attributes.project_type,
                        estimated_sum: item.attributes.estimated_sum,
                        estimated_duration_days: item.attributes.estimated_duration_days,
                        start_date: item.attributes.start_date,
                        end_date: item.attributes.end_date,
                        company_code: item.attributes.company_code,
                        customer_id: item.attributes.customer_id,
                        created_at: item.attributes.created_at,
                        updated_at: item.attributes.updated_at
                    };
                });

                return projects;
            }
            else if (response.status === 404) { //for no companies is found with this account!!
                return [];
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else {

                throw new Error(`${responseBody.error} status ${response.status}`);

            }

        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to get project: ${error.message}`);
            } else {
                throw new Error('Failed to get project: An unknown error occurred.');
            }
        }
    }



    static async update(project_id: string, project: Project) {
        try {
            const response = await fetch(`${API_BASE_URL}/projects/${project_id}`, {
                method: 'PATCH',
                credentials: 'include',  // If you need to send cookies
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ project: project }),
            });

            const responseBody = await response.json();

            if (response.status === 200) {
                //return company;
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else {
                //console.log('body======', responseBody.error, `Status ${response.status}`);

                throw new Error(`${responseBody.error}, status: ${response.status}`);
            }
        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to update project: ${error.message}`);
            } else {
                throw new Error('Failed to update project: An unknown error occurred.');
            }
        }
    }

    static async delete(project_id: string) {
        try {
            const response = await fetch(`${API_BASE_URL}/projects/${project_id}`, {
                method: 'DELETE',
                credentials: 'include',  // If you need to send cookies
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            const responseBody = await response.json();
            //console.log('body======', response.status);

            if (response.status === 200) {
                //return company;
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else {
                throw new Error(`${responseBody.error}, status: ${response.status}`);
            }
        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to delete project: ${error.message}`);
            } else {
                throw new Error('Failed to delete project: An unknown error occurred.');
            }
        }
    }

}

export default ProjectApi;